import React from 'react';

export type TodoThumbnailProps = {
  thumbnailSrc: string,
  backgroundColor: string,
};

function TodoThumbnail({
  thumbnailSrc,
  backgroundColor,
}: TodoThumbnailProps) {
  return (
    <div className='todo-cover'>
      {thumbnailSrc
        ? <img src={thumbnailSrc} alt='' />
        : <div className='square-thumbnail' style={{ backgroundColor }} />}
    </div>
  );
}

export default TodoThumbnail;
